import common from './common'

export default {
  extends: common,
  props: {
    totalAmount: { type: Number, required: true, default: 0 },
    promotions: { type: Array, default: () => [] },
  },
  computed: {
    bestPrice() {
      const availability = this.promotion.availability

      const summary = {
        code: null,
        date: null,
        language: null,
        season: null,
        price: this.totalAmount,
        layaway: 0,
        discount: 0,
        sale_price: 0,
      }

      if (this.promoType === 'promo_general') {
        summary.discount = this.discountValue(summary.price)
      } else if (this.promoType.endsWith('_dates')) {
        if (this.validateDate(summary)) {
          summary.discount = this.discountValue(summary.price)
        }
      }
      summary.sale_price = summary.price - summary.discount

      if (typeof availability !== 'undefined') {
        if (this.validateDate(availability)) {
          availability.discount = this.discountValue(availability.price)
        } else {
          availability.discount = 0
        }

        availability.sale_price = availability.price - availability.discount
      }

      return typeof availability === 'undefined' ||
        summary.sale_price < availability.sale_price
        ? summary
        : availability
    },
  },
  methods: {
    discountValue(amount) {
      let value = 0

      if (this.promotion.discount_type === 'promotion_percent') {
        value += (parseFloat(amount) * this.promotion.value) / 100
      } else {
        /** descuento por monto */
      }

      return value
    },
  },
}
